/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1MylibraryStudentsCandidatesDropdown200,
  GetApiV1MylibraryStudentsCandidatesDropdown401,
  GetApiV1MylibraryStudentsCandidatesDropdown500,
  GetApiV1MylibraryStudentsCandidatesDropdownQueryParams,
  GetApiV1MylibraryStudentsCandidatesDropdownQueryResponse,
} from "../../types/myLibraryCandidatosController/GetApiV1MylibraryStudentsCandidatesDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1MylibraryStudentsCandidatesDropdownQueryParamsSchema = z
  .object({
    ClassStudentIds: z.optional(
      z
        .array(z.coerce.number().int())
        .describe(
          "IDs das turmas a filtrar. Lista vazia considera todas as turmas. Opcional.",
        ),
    ),
    Filter: z.optional(
      z
        .string()
        .describe(
          "Texto de busca aplicado ao nome da pessoa. A comparação ignora maiúsculas e minúsculas. Opcional.",
        ),
    ),
  })
  .optional() as unknown as ToZod<GetApiV1MylibraryStudentsCandidatesDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1MylibraryStudentsCandidatesDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1MylibraryStudentsCandidatesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1MylibraryStudentsCandidatesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryStudentsCandidatesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1MylibraryStudentsCandidatesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryStudentsCandidatesDropdown500>;

export const getApiV1MylibraryStudentsCandidatesDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1MylibraryStudentsCandidatesDropdown200Schema,
  ) as unknown as ToZod<GetApiV1MylibraryStudentsCandidatesDropdownQueryResponse>;
